export default __webpack_public_path__ + "static/media/amir_bilder.3f8b4d08.jpeg";